<template>
  <div class="wombat-footer">
    <div
      class="cell footer-column"
      v-for="column in preparedColumns"
      :key="column.name"
      :title="column.title"
      :class="[column.class, column._className]"
    >
      <div class="content">
        <slot name="footer-cell" :column="column">
          {{ column.title }}
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WombatFooter',
  props: {
    columns: {
      type: Array,
      required: true,
    },
  },
  computed: {
    preparedColumns() {
      const columns = this.columns.map((item, index) => {
        const style = {};

        if (item.width) {
          style.width = item.width;
        } else {
          style.flex = 1;
        }

        const machineName = (item.name || `column${index}`).toLowerCase().replace(/\W/g, '');

        return {
          ...item,
          _className: `column-${machineName}`,
          style,
        };
      });
      return columns;
    },
  },
};
</script>

<style scoped lang="scss">
.wombat-footer {
  width: 100%;
  display: flex;
  flex-direction: row;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.cell {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
}

.content {
  flex: 1;
}

.footer-column-ellipsis .content {
  white-space: nowrap;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
